import { render, staticRenderFns } from "./add-or-update-situation.vue?vue&type=template&id=f8b5b4a2&scoped=true&"
import script from "./add-or-update-situation.vue?vue&type=script&lang=js&"
export * from "./add-or-update-situation.vue?vue&type=script&lang=js&"
import style0 from "./add-or-update-situation.vue?vue&type=style&index=0&id=f8b5b4a2&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b5b4a2",
  null
  
)

export default component.exports